(function() {
    'use strict';

    angular
        .module('app')
        .factory('ImportService',
            function(WebApiService) {

                var routePrefix = '/api/import';

                return {
                    htsFlashEdit: function(uploadedFile) {
                        return WebApiService.postJson(routePrefix + '/hts-flash-edit', uploadedFile);
                    }
                };
            });
})();
